import script from "./UserAddModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserAddModal.vue?vue&type=script&lang=ts&setup=true"

import "./UserAddModal.vue?vue&type=style&index=0&id=3e09d216&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e09d216"]])

export default __exports__